import { useEffect, useState } from 'react';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Divider,
  Drawer,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  Container,
  Paper
} from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Scrollbar from '../Scrollbar';
import CheckIcon from '../../icons/Check';
import Modal from '@material-ui/core/Modal';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ConfiguratorField from '../../components/configurator/Field';
import { settings } from '../../settings';
import { st } from '../../state';
import { proxy } from 'valtio';

const DashboardSidebar = (props) => {
  const { onMobileClose, openMobile } = props;
  const location = useLocation();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'), { noSsr: true });
  const state = proxy(st);

  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%'
    },
    heading: {
      fontSize: theme.typography.pxToRem(13)
    },
    drawerHeader: {
      display: 'flex',
      zIndex: 99,
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
      height: 64,
      width: 270
    }
  }));

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const classes = useStyles();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const handleSubmit = (event) => {
    event.preventDefault();
    alert('Disabled');
    return;
    var lz = require('lz-string');
    let obj = JSON.stringify({ state }, null, 0);
    let comp = lz.compressToEncodedURIComponent(obj);
    let data = { ...state };
    data.data = comp;

    axios({
      method: 'post',
      url: '/send.php',
      data: data,
      headers: { 'content-type': 'application/json' }
    })
      .then((result) => {
        handleOpen();
      })
      .catch((error) => {
        alert('Error: ' + error.message);
      });
  };

  let fields = [];
  settings.map((parent, i) => {
    if (parent.label && parent.id != 'contact') {
      fields.push(
        <Accordion TransitionProps={{ unmountOnExit: false, mountOnEnter: true }} key={parent.id}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={'panel' + i + 'a-content'}
            id={'panel' + i + 'a-header'}
          >
            <Typography variant="button" className={classes.heading}>
              {parent.label}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {parent.fields.map((field) => (
              <ConfiguratorField key={field.id} parentId={parent.id} state={state} {...field} />
            ))}
          </AccordionDetails>
        </Accordion>
      );
    }
    if (parent.id == 'contact') {
      fields.push(
        <Box key="contact-label" sx={{ pt: 4 }}>
          <Divider />
          <Box key="contact-wrapper" sx={{ pt: 2 }}>
            <Typography variant="button" className={classes.heading}>
              {parent.label}
            </Typography>
          </Box>
        </Box>
      );
      parent.fields.map((field) => {
        fields.push(<ConfiguratorField key={field.id} parentId={parent.id} state={state} {...field} />);
      });
    }
  });

  const content = (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}
      >
        <Scrollbar options={{ suppressScrollX: true }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              p: 2
            }}
          >
            <RouterLink to="/">
              <img
                src="/main_logo_dark.png"
                style={{ maxWidth: '30%', marginLeft: 'auto', marginRight: 'auto', display: 'block' }}
              />
            </RouterLink>
          </Box>
          <form onSubmit={handleSubmit}>
            <Box sx={{ p: 2 }}>{fields}</Box>
            <Divider />
            <Box sx={{ p: 2 }}>
              <Typography color="textPrimary" variant="subtitle2">
                Submit Plans & Get a Quote
              </Typography>
              <Typography color="textSecondary" variant="body2">
                Send an email with your name, number, along with your 3D building plans you would like to get a quote
                for.
              </Typography>
              <Button color="secondary" fullWidth sx={{ mt: 2 }} variant="contained" type="submit">
                Send
              </Button>
            </Box>
          </form>
        </Scrollbar>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Container maxWidth="sm">
            <Paper elevation={12} sx={{ p: 3 }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <Avatar
                  sx={{
                    backgroundColor: (theme) => alpha(theme.palette.success.main, 0.08),
                    color: 'success.main',
                    mb: 2
                  }}
                >
                  <CheckIcon />
                </Avatar>
                <Typography color="textPrimary" variant="h5">
                  Email Sent!
                </Typography>
                <Typography align="center" color="textSecondary" sx={{ mt: 1 }} variant="body2">
                  Your plans have been submitted. We will get back with you with a quote very soon! Thank you.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  mt: 4
                }}
              >
                <Button color="secondary" fullWidth size="large" variant="contained" onClick={handleClose}>
                  Close
                </Button>
              </Box>
            </Paper>
          </Container>
        </Box>
      </Modal>
    </>
  );

  if (lgUp) {
    // if (true) {
    return (
      <Drawer
        anchor="left"
        open
        PaperProps={{
          sx: {
            backgroundColor: 'background.paper',
            height: '100% !important',
            top: '0 !Important',
            width: 280
          }
        }}
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={onMobileClose}
      open={openMobile}
      PaperProps={{
        sx: {
          backgroundColor: 'background.paper',
          width: 280
        }
      }}
      variant="persistent"
    >
      {content}
    </Drawer>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default DashboardSidebar;
